import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Grid } from 'antd';

import { ScoreBadge } from './ScoreBadge';
import { getCategoryScores } from './categoryScoreStrategies';

import type { CategoryScore } from '@/components/views/Report/KimLhc/Report/Steps/Result/Constants';
import type { KimLhcCategories } from '@/types';
import { KimLhcCategoryKey } from '@/types';

import * as S from '@/components/views/Report/KimLhc/Report/Steps/Result/styles';

interface CategoryHeaderProps {
	category: CategoryScore;
	categories: KimLhcCategories;
}

export function CategoryHeader({ category, categories }: Readonly<CategoryHeaderProps>) {
	const screens = Grid.useBreakpoint();
	const isCompact = !screens.xl;
	const scores = getCategoryScores(category.contentKey, categories, category);
	const compactGenderLabels = ['Men', 'Women'];
	const shouldCompactWeightLabels = isCompact && category.contentKey === KimLhcCategoryKey.WEIGHT;

	function getScoreLabel(scoreLabel: string, index: number): string {
		if (!shouldCompactWeightLabels) {
			return scoreLabel;
		}

		return compactGenderLabels[index] ?? scoreLabel;
	}

	return (
		<S.CategoryHeader>
			<S.CategoryTitle>{I18n.get(category.titleKey)}</S.CategoryTitle>
			<S.ScoreBadgeContainer>
				{scores.map((scoreData, index) => (
					<ScoreBadge
						key={index}
						score={scoreData.score}
						maxScore={scoreData.maxScore}
						label={getScoreLabel(scoreData.label, index)}
					/>
				))}
			</S.ScoreBadgeContainer>
		</S.CategoryHeader>
	);
}
